<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="工作流"
      width="1200px"
      @close="close()">
    <div>
      <handle-detail v-if="billId!=='null'" :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
    </div>
  </el-dialog>
</template>

<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  export default {
    name: "",
    components: { HandleDetail },
    data() {
      return {
        dialogVisible: false,
        billId: "0",
        billType: "0",
        // billType: "0",
        data: [],
        contentLoading: false,
      };
    },
    methods: {
      open(id,type) {
        this.dialogVisible = true;
        this.billId = id;
        this.billType = type;
      },
      close() {
        this.dialogVisible = false;
        this.billId = "null";
        this.billType = "";
      },
    },
  };
</script>
